const LOCAL_API_URL = 'http://localhost:3000/';
const STAGING_API_URL = 'https://staging.backend.yourprivatetrip.com/';
const PRODUCTION_API_URL = 'https://backend.yourprivatetrip.com/';

export const API_URL = import.meta.env.DEV
  ? LOCAL_API_URL
  : import.meta.env.MODE === 'staging'
    ? STAGING_API_URL
    : PRODUCTION_API_URL;
